import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

import Iconify from 'src/components/iconify';
import { Box, Typography } from '@mui/material';


// ----------------------------------------------------------------------

export default function BeforeAfterModal({open, onClose, item }) {
  const logoPath = '/logo/nav-logo.png';

    // const beforeImages = ["https://res.cloudinary.com/ds0yjmcgj/image/upload/v1734072383/IMG_5401_mp2sag.jpg", "https://res.cloudinary.com/ds0yjmcgj/image/upload/v1734072388/IMG_5402_kq3n4r.jpg", "https://res.cloudinary.com/ds0yjmcgj/image/upload/v1734072382/IMG_5403_kj5ral.jpg", "https://res.cloudinary.com/ds0yjmcgj/image/upload/v1734072383/IMG_5405_muxsan.jpg", "https://res.cloudinary.com/ds0yjmcgj/image/upload/v1734072383/IMG_5406_og1wwp.jpg", "https://res.cloudinary.com/ds0yjmcgj/image/upload/v1734072388/IMG_5407_viypor.jpg", "https://res.cloudinary.com/ds0yjmcgj/image/upload/v1734072385/IMG_5408_dqw8go.jpg"];
    // const afterImages = ["https://res.cloudinary.com/ds0yjmcgj/image/upload/v1734072357/IMG_5409_z7e3nj.jpg", "https://res.cloudinary.com/ds0yjmcgj/image/upload/v1734072349/IMG_5410_wwjhe0.jpg", "https://res.cloudinary.com/ds0yjmcgj/image/upload/v1734072351/IMG_5411_my4pfb.jpg", "https://res.cloudinary.com/ds0yjmcgj/image/upload/v1734072352/IMG_5412_vjwjog.jpg", "https://res.cloudinary.com/ds0yjmcgj/image/upload/v1734072351/IMG_5413_ggvqzo.jpg", "https://res.cloudinary.com/ds0yjmcgj/image/upload/v1734072350/IMG_5414_xbrvjp.jpg", "https://res.cloudinary.com/ds0yjmcgj/image/upload/v1734072354/IMG_5415_hfrlwh.jpg", "https://res.cloudinary.com/ds0yjmcgj/image/upload/v1734072352/IMG_5416_e48dp3.jpg", "https://res.cloudinary.com/ds0yjmcgj/image/upload/v1734072352/IMG_5417_kxgskk.jpg"];
    const beforeImages = item?.images?.beforeImages
    const afterImages = item?.images?.afterImages

  return (
    <Dialog fullWidth maxWidth="md" open={open} onClose={onClose}>
        <DialogTitle sx={{ p: (theme) => theme.spacing(3, 3, 2, 3), background: '#F4F6F8', mb: 2 }}>
        <Box
        >
          {/* <Logo sx={{ height: '30px', width: '150px' }} /> */}
          <img className="nav-logo" height={30} src={logoPath} alt="logo" />
          <Iconify
            icon="ri:close-line"
            style={{ position: 'absolute', right: '30px',marginTop:"5px", cursor: 'pointer' }}
            onClick={onClose}
          />
        </Box>
        
        </DialogTitle>

        <DialogContent dividers sx={{ pt: 1, pb: 0, border: 'none' }}>
        <Box
            gap={3}
            display="grid"
            gridTemplateColumns={{
              md: 'repeat(1, 1fr)',
              lg: 'repeat(2, 1fr)',
            }}
          >
      <Box>
        <Typography variant='h6' mb={2}>
            Before
        </Typography>
        {beforeImages?.map((img, index) => (
              <Box key={index} sx={{ mb: 2 }}>
                <img  src={img} alt={`Before ${index + 1}`} style={{ width: '100%',borderRadius:"10px"}} />
              </Box>
            ))}
      </Box>
      <Box>
      <Typography variant='h6' mb={2}>
            After
        </Typography>
        {afterImages?.map((img, index) => (
              <Box key={index} sx={{ mb: 2 }}>
                <img src={img} alt={`After ${index + 1}`} style={{ width: '100%' }} />
              </Box>
            ))}
        </Box>

            </Box>
         

        </DialogContent>
        <DialogActions>
     
          <Button variant="outlined" onClick={onClose} className="danager">
            Cancel
          </Button>
  


        </DialogActions>
    </Dialog>
  );
}

BeforeAfterModal.propTypes = {
  onClose: PropTypes.func,
  open: PropTypes.bool,

};
